import httpClient from ".";

export const API_CAPITAL_PATH = "/user/capital";
export const API_CAPITAL_CANCEL_PATH = "/user/cancel-capital";

export const getAll = () => httpClient.get(`${API_CAPITAL_PATH}`);

export const create = data => httpClient.post(API_CAPITAL_PATH, data);

export const edit = ({ id, ...data }) =>
  httpClient.put(`${API_CAPITAL_PATH}/${id}`, data);

export const remove = id =>
  httpClient.post(`${API_CAPITAL_CANCEL_PATH}/${id}`, { id });

export const detail = id => httpClient.get(`${API_CAPITAL_PATH}/${id}`);
